import { PersonaConfig } from "../types";
import type { ShopifyCustomerSummary } from "../shopify/client";

export const PERSONAS: PersonaConfig[] = [
  // ── Existing rich-profile personas (CUST-00056 – 00059) ─────────────────────
  {
    id: "liam",
    name: "Liam Taylor",
    role: "Returning Customer",
    avatarInitials: "LT",
    avatarBg: "from-blue-500 to-indigo-600",
    tagLine: "Smart speaker label created 3 days ago — console return just settled",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-941-2850",
    accountId: "CUST-00056",
    memberSince: "Mar 2024",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260586", product: "Aero Smart Speaker",  status: "label_created", carrier: "OnTrac",   trackingNumber: "TRK923159338", eta: "Apr 25", date: "Apr 22" },
      { orderId: "VE-20260587", product: "VoltEdge Air 13",     status: "delivered",     carrier: "OnTrac",   trackingNumber: "TRK181403777", date: "Apr 12" },
      { orderId: "VE-20260588", product: "NextPlay Console",    status: "returned",      carrier: "FedEx",    trackingNumber: "TRK844470595", date: "Apr 1" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["Where is my Aero Smart Speaker? Label was created 3 days ago", "Has VE-20260586 actually shipped yet?", "Any updates on TRK923159338?", "My speaker still shows label created"],
      cancellation: ["Did my NextPlay Console refund go through?", "I returned the console — when do I get my money back?", "Can I get store credit instead of the gift card refund?", "I want to cancel my smart speaker before it ships"],
      "store-desk": ["Can I pick up my speaker at a Charlotte store?", "Is the VoltEdge Air 13 available for in-store exchange?"],
      "product-rec":["What pairs well with my VoltEdge Air 13 laptop?", "Best wireless speakers under $200?"],
    },
  },
  {
    id: "aurora",
    name: "Aurora Taylor",
    role: "Issue Resolution",
    avatarInitials: "AT",
    avatarBg: "from-rose-500 to-pink-600",
    tagLine: "Gaming console stuck in exception — investigation open, 88% loss probability",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-231-8897",
    accountId: "CUST-00057",
    memberSince: "Aug 2023",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260590", product: "Arcadia X Console",  status: "exception",     carrier: "LaserShip", trackingNumber: "TRK359000705", eta: "Apr 12", date: "Apr 8" },
      { orderId: "VE-20260591", product: "VoltEdge Tab 11",    status: "in_transit",    carrier: "OnTrac",    trackingNumber: "TRK481504540", eta: "Mar 30", date: "Mar 25" },
      { orderId: "VE-20260589", product: "Arcadia S Console",  status: "label_created", carrier: "UPS",       trackingNumber: "TRK367176006", eta: "Mar 26", date: "Mar 22" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["My Arcadia X Console hasn't had a scan in weeks", "Is VE-20260590 lost? No updates since Apr 12", "I need to open a lost package investigation", "Where is TRK359000705 right now?"],
      cancellation: ["I want a full refund — my console never arrived", "Can I cancel VE-20260590 and get a replacement?", "How long does a LaserShip insurance claim take?", "I want to reorder but need credit applied first"],
      "store-desk": ["Is the Arcadia X Console in stock at a Minneapolis store?", "Can I pick up a replacement console in-store?"],
      "product-rec":["What's a reliable alternative gaming console?", "Best accessories for the VoltEdge Tab 11?"],
    },
  },
  {
    id: "penelope",
    name: "Penelope Clark",
    role: "Power Buyer",
    avatarInitials: "PC",
    avatarBg: "from-violet-500 to-purple-600",
    tagLine: "Wearable return with $298 refund in progress — headphones still in transit",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-619-3976",
    accountId: "CUST-00058",
    memberSince: "Jan 2022",
    loyaltyTier: "Platinum",
    orders: [
      { orderId: "VE-20260594", product: "VoltBand Fit",      status: "returned",   carrier: "OnTrac",    trackingNumber: "TRK436148278", date: "Apr 6" },
      { orderId: "VE-20260593", product: "SonicWave Lite",    status: "in_transit", carrier: "LaserShip", trackingNumber: "TRK979478697", eta: "Apr 6", date: "Apr 3" },
      { orderId: "VE-20260592", product: "VoltEdge One",      status: "delivered",  carrier: "USPS",      trackingNumber: "TRK948145262", date: "Apr 6" },
    ],
    bestFor: ["cancellation", "product-rec"],
    suggestedQuestions: {
      cancellation: ["When will my $298 VoltBand refund be processed?", "I returned the wearable — status says processing but nothing's changed", "Can I get store credit instead?", "I want to exchange VoltBand Fit for a different model"],
      "product-rec":["What's a better fitness tracker to replace VoltBand Fit?", "I have a VoltEdge One — what accessories go well with it?", "Best noise-cancelling headphones to pair with my phone?", "Complete WFH setup recommendations for a Platinum member?"],
      wismo:        ["Where are my SonicWave Lite headphones?", "My headphones were supposed to arrive Apr 6 — any updates?"],
      "store-desk": ["Can I return my VoltBand in-store instead?", "Is the VoltEdge One available at Austin stores for demo?"],
    },
  },
  {
    id: "grace",
    name: "Grace Harris",
    role: "First-time Buyer",
    avatarInitials: "GH",
    avatarBg: "from-emerald-500 to-teal-600",
    tagLine: "TV refund of $1,399 in progress — store pickup still pending for NovaRing",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-544-8444",
    accountId: "CUST-00059",
    memberSince: "Oct 2025",
    loyaltyTier: "Bronze",
    orders: [
      { orderId: "VE-20260596", product: "ViewMax 65 QLED",       status: "returned",      carrier: "OnTrac", trackingNumber: "TRK856920079", date: "Apr 5" },
      { orderId: "VE-20260595", product: "NovaRing",              status: "pickup_processing", carrier: "USPS", trackingNumber: "TRK329427256", eta: "Mar 26", date: "Mar 23" },
      { orderId: "VE-20260597", product: "VoltEdge Creator 32",   status: "in_transit",    carrier: "UPS",    trackingNumber: "TRK865531582", eta: "Mar 28", date: "Mar 23" },
    ],
    bestFor: ["store-desk", "cancellation", "product-rec"],
    suggestedQuestions: {
      "store-desk": ["Can I pick up my NovaRing at a Denver store?", "My store pickup for VE-20260595 is overdue — what happened?", "What are the return policy terms for in-store returns?"],
      cancellation: ["When will I get my $1,399 ViewMax TV refund?", "My TV refund was initiated Apr 5 — it's been over 3 weeks", "Can I get gift card credit instead of waiting for bank refund?"],
      wismo:        ["Where is my NovaRing? Pickup was supposed to be Mar 26", "Any updates on my VoltEdge Creator monitor — ETA Mar 28?"],
      "product-rec":["What's a better 65-inch TV than the ViewMax QLED?", "Best monitors for creative work under $700?"],
    },
  },

  // ── 20 additional customers from CRM ────────────────────────────────────────
  {
    id: "owen",
    name: "Owen Green",
    role: "Platinum Member",
    avatarInitials: "OG",
    avatarBg: "from-amber-500 to-orange-600",
    tagLine: "NovaBook 14 ready for pickup in Dallas — Platinum, high-value buyer",
    email: "parambir.singh@nurix.ai",
    phone: "+1-555-619-8441",
    accountId: "CUST-00001",
    memberSince: "Jan 2021",
    loyaltyTier: "Platinum",
    orders: [
      { orderId: "VE-20260501", product: "NovaBook 14", status: "ready_for_pickup", carrier: "LaserShip", trackingNumber: "TRK248235679", eta: "Apr 4", date: "Mar 31" },
    ],
    bestFor: ["store-desk", "wismo"],
    suggestedQuestions: {
      "store-desk": ["My laptop is ready for pickup — which Dallas store?", "Can I get same-day pickup for VE-20260501?", "What do I need to bring for store pickup?"],
      wismo:        ["Where is my NovaBook 14 order VE-20260501?", "Can someone confirm it's at the store?"],
      "product-rec":["What accessories go well with the NovaBook 14?", "Best laptop bag for the NovaBook 14?"],
      cancellation: ["I want to cancel my laptop order before pickup", "Can I return the NovaBook 14 if I change my mind?"],
    },
  },
  {
    id: "leo",
    name: "Leo Green",
    role: "Platinum Member",
    avatarInitials: "LG",
    avatarBg: "from-cyan-500 to-blue-600",
    tagLine: "Aurora Gaming 16 just delivered — Platinum buyer open to upgrade offers",
    email: "anantika@nurix.ai",
    phone: "+1-555-815-1893",
    accountId: "CUST-00002",
    memberSince: "Mar 2021",
    loyaltyTier: "Platinum",
    orders: [
      { orderId: "VE-20260502", product: "Aurora Gaming 16", status: "delivered", carrier: "UPS", trackingNumber: "TRK251044969", date: "Apr 7" },
    ],
    bestFor: ["product-rec"],
    suggestedQuestions: {
      "product-rec":["My Aurora Gaming 16 just arrived — what peripherals do you recommend?", "Best gaming monitor to pair with the Aurora Gaming 16?", "What's a good mechanical keyboard for gaming under $150?", "Complete gaming desk setup recommendations?"],
      cancellation: ["I want to return the Aurora Gaming 16 — it doesn't meet expectations", "Does the Aurora Gaming 16 have a warranty?"],
      wismo:        ["Has my Aurora Gaming 16 delivered? Any follow-up shipments?"],
      "store-desk": ["Can I get a demo session for my new gaming laptop at a Denver store?"],
    },
  },
  {
    id: "hudson",
    name: "Hudson Martinez",
    role: "New Customer",
    avatarInitials: "HM",
    avatarBg: "from-lime-500 to-green-600",
    tagLine: "Security camera delayed by carrier capacity — due Apr 22",
    email: "anuj.jain@nurix.ai",
    phone: "+1-555-634-6745",
    accountId: "CUST-00003",
    memberSince: "Feb 2026",
    loyaltyTier: "Bronze",
    orders: [
      { orderId: "VE-20260503", product: "Horizon Security Cam Pro", status: "delayed", carrier: "UPS", trackingNumber: "TRK751725979", eta: "Apr 22", date: "Apr 16" },
    ],
    bestFor: ["wismo"],
    suggestedQuestions: {
      wismo:        ["My security camera was supposed to arrive but it's delayed", "Why is VE-20260503 stuck? It shows carrier capacity issues", "Any update on my UPS shipment TRK751725979?", "Can I get expedited shipping on my camera?"],
      cancellation: ["I want to cancel my camera order due to the delay", "Can I get a discount for the late delivery?"],
      "product-rec":["What's a better security camera that ships faster?", "Recommend a reliable outdoor security camera under $250?"],
      "store-desk": ["Is the Horizon Security Cam Pro available at a Phoenix store?"],
    },
  },
  {
    id: "isabellah",
    name: "Isabella Harris",
    role: "Returning Customer",
    avatarInitials: "IH",
    avatarBg: "from-pink-500 to-rose-600",
    tagLine: "Router label created 25 days ago — $368 refund already initiated",
    email: "asawa@nurix.ai",
    phone: "+1-555-971-7254",
    accountId: "CUST-00004",
    memberSince: "Jun 2023",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260504", product: "ArcLink 6E Router", status: "label_created", carrier: "FedEx", trackingNumber: "TRK654107112", eta: "Apr 3", date: "Mar 29" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["My router label was created Mar 29 but it still hasn't shipped", "Why is VE-20260504 stuck at label created?", "Can you check if FedEx actually picked up my router?"],
      cancellation: ["I already started a refund — what's the status of my $368?", "Is my router refund going back to original payment method?", "I want to cancel VE-20260504 and get my money back ASAP"],
      "product-rec":["While I wait — what's a good mesh WiFi alternative?", "Recommend a router that ships within 2 days?"],
      "store-desk": ["Can I pick up a router at a Nashville store instead?"],
    },
  },
  {
    id: "madison",
    name: "Madison Lee",
    role: "Returning Customer",
    avatarInitials: "ML",
    avatarBg: "from-orange-500 to-amber-600",
    tagLine: "50\" LED TV delayed due to sortation — previous shipment complaint on file",
    email: "chirag@nurix.ai",
    phone: "+1-555-231-4018",
    accountId: "CUST-00005",
    memberSince: "Aug 2022",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260505", product: "Horizon 50 LED", status: "delayed", carrier: "FedEx", trackingNumber: "TRK260321290", eta: "Apr 12", date: "Apr 6" },
    ],
    bestFor: ["wismo"],
    suggestedQuestions: {
      wismo:        ["My TV was supposed to arrive Apr 10 and it's still delayed", "Why is my Horizon 50 LED stuck in Las Vegas?", "Can FedEx expedite my TV delivery TRK260321290?", "This is my second bad shipment experience with you"],
      cancellation: ["I want to cancel VE-20260505 — I need the TV sooner", "Can I get a discount or free shipping on my next order for this delay?"],
      "product-rec":["What's a comparable TV that's in stock and ships fast?"],
      "store-desk": ["Is the Horizon 50 LED available for pickup at a Denver store?"],
    },
  },
  {
    id: "avag",
    name: "Ava Garcia",
    role: "Issue Resolution",
    avatarInitials: "AG",
    avatarBg: "from-red-500 to-rose-600",
    tagLine: "Fiber Hub in exception since Mar 20 — investigation open, 97% loss probability",
    email: "yashvi@nurix.ai",
    phone: "+1-555-607-9463",
    accountId: "CUST-00008",
    memberSince: "Sep 2022",
    loyaltyTier: "Silver",
    orders: [
      { orderId: "VE-20260508", product: "VoltEdge Fiber Hub", status: "exception", carrier: "USPS", trackingNumber: "TRK630762564", eta: "Mar 24", date: "Mar 20" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["My VoltEdge Fiber Hub has been in exception since Mar 20 — 5+ weeks ago", "Is my router lost? USPS shows exception at local facility", "I need to file a lost package claim for TRK630762564", "What's the investigation status on VE-20260508?"],
      cancellation: ["I want a full refund or replacement — this package is lost", "Can I get an emergency replacement shipped?", "How long will the insurance investigation take?"],
      "store-desk": ["Is the VoltEdge Fiber Hub in stock at a Seattle store?"],
      "product-rec":["What's a good alternative to the VoltEdge Fiber Hub?"],
    },
  },
  {
    id: "gracet",
    name: "Grace Thomas",
    role: "Returning Customer",
    avatarInitials: "GT",
    avatarBg: "from-teal-500 to-green-600",
    tagLine: "Headphones stuck at label created — store pickup, $129 refund for delay",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-584-5455",
    accountId: "CUST-00010",
    memberSince: "Apr 2023",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260510", product: "SonicWave Lite", status: "label_created", carrier: "USPS", trackingNumber: "TRK139902850", eta: "Apr 2", date: "Mar 31" },
    ],
    bestFor: ["wismo", "cancellation", "store-desk"],
    suggestedQuestions: {
      wismo:        ["My headphones label was created Mar 31 — it's been 4 weeks with no pickup", "Why hasn't VE-20260510 been processed for store pickup?", "Can someone check the status at the Raleigh store?"],
      cancellation: ["I already have a $129 refund initiated — what's the status?", "I want to cancel and get my refund processed faster"],
      "store-desk": ["Can I pick up my SonicWave headphones at a Raleigh store?", "Why is my store pickup still at label created stage?"],
      "product-rec":["What are better alternatives to the SonicWave Lite under $150?"],
    },
  },
  {
    id: "harper",
    name: "Harper King",
    role: "Tech Enthusiast",
    avatarInitials: "HK",
    avatarBg: "from-sky-500 to-cyan-600",
    tagLine: "VoltEdge Pro 15 just delivered — Silver member, open to upgrade suggestions",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-547-6612",
    accountId: "CUST-00013",
    memberSince: "Jan 2024",
    loyaltyTier: "Silver",
    orders: [
      { orderId: "VE-20260513", product: "VoltEdge Pro 15", status: "delivered", carrier: "OnTrac", trackingNumber: "TRK403269534", date: "Mar 31" },
    ],
    bestFor: ["product-rec"],
    suggestedQuestions: {
      "product-rec":["My VoltEdge Pro 15 arrived — what accessories do you recommend?", "Best external monitor for VoltEdge Pro 15 under $400?", "I want to set up a full WFH station — what do I need?", "Any student discount on accessories for my new laptop?"],
      cancellation: ["The VoltEdge Pro 15 doesn't have the RAM I expected — can I return it?", "How do I start a return for a delivered laptop?"],
      "store-desk": ["Can I get setup help at a San Diego store?"],
      wismo:        ["I got the laptop — are there any remaining items in my order?"],
    },
  },
  {
    id: "layla",
    name: "Layla Clark",
    role: "VIP Member",
    avatarInitials: "LC",
    avatarBg: "from-indigo-500 to-violet-600",
    tagLine: "VoltEdge CloudBox in transit — Platinum, very sensitive to delays",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-769-9900",
    accountId: "CUST-00014",
    memberSince: "May 2020",
    loyaltyTier: "Platinum",
    orders: [
      { orderId: "VE-20260514", product: "VoltEdge CloudBox", status: "in_transit", carrier: "UPS", trackingNumber: "TRK177112710", eta: "Apr 15", date: "Apr 12" },
    ],
    bestFor: ["wismo"],
    suggestedQuestions: {
      wismo:        ["Where exactly is my VoltEdge CloudBox? I'm a Platinum member", "Why hasn't VE-20260514 updated in 2 days?", "Can I get priority tracking updates on TRK177112710?", "I need my console by Thursday — is Apr 15 guaranteed?"],
      cancellation: ["If it's delayed past Apr 15 I want to cancel and get priority shipping", "What's the VIP policy for late deliveries?"],
      "product-rec":["What games and accessories are available for the CloudBox?"],
      "store-desk": ["Can I pick up my CloudBox at a San Diego store instead of waiting?"],
    },
  },
  {
    id: "luna",
    name: "Luna Harris",
    role: "New Customer",
    avatarInitials: "LH",
    avatarBg: "from-fuchsia-500 to-purple-600",
    tagLine: "Received wrong item on laptop order — $449.50 partial refund in processing",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-667-1718",
    accountId: "CUST-00015",
    memberSince: "Jan 2026",
    loyaltyTier: "Bronze",
    orders: [
      { orderId: "VE-20260515", product: "VoltEdge Air 13", status: "returned", carrier: "UPS", trackingNumber: "TRK864156912", date: "Apr 21" },
    ],
    bestFor: ["cancellation"],
    suggestedQuestions: {
      cancellation: ["I received the wrong item on my laptop order — where is my $449.50 refund?", "It's been 10 days since I initiated the return — when does processing finish?", "Can I exchange for the correct model instead of a refund?", "My refund was supposed to arrive Apr 18 — it's late"],
      wismo:        ["I returned my laptop — can you confirm it was received?"],
      "product-rec":["What's the correct VoltEdge Air 13 model I should order?"],
      "store-desk": ["Can I do the exchange at an Austin store instead of mailing it back?"],
    },
  },
  {
    id: "evelyn",
    name: "Evelyn Anderson",
    role: "New Customer",
    avatarInitials: "EA",
    avatarBg: "from-yellow-500 to-amber-600",
    tagLine: "65\" QLED TV ready for pickup in Dallas — waiting on store confirmation",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-966-4806",
    accountId: "CUST-00016",
    memberSince: "Mar 2026",
    loyaltyTier: "Bronze",
    orders: [
      { orderId: "VE-20260516", product: "ViewMax 65 QLED", status: "ready_for_pickup", carrier: "OnTrac", trackingNumber: "TRK539636515", eta: "Apr 16", date: "Apr 7" },
    ],
    bestFor: ["store-desk"],
    suggestedQuestions: {
      "store-desk": ["My ViewMax 65 QLED is ready for pickup — which Dallas store?", "How long do I have to pick up my TV before it's restocked?", "Do I need an ID and confirmation email for TV pickup?", "Can someone else pick up my TV for me?"],
      wismo:        ["I see my TV is ready for pickup — is it definitely at the store?"],
      cancellation: ["I need to cancel my TV pickup — changed my mind"],
      "product-rec":["What mounting hardware and soundbars pair with the ViewMax 65 QLED?"],
    },
  },
  {
    id: "hazel",
    name: "Hazel Anderson",
    role: "Returning Customer",
    avatarInitials: "HA",
    avatarBg: "from-purple-500 to-fuchsia-600",
    tagLine: "NextPlay Console in transit via USPS — Gold, delay-sensitive customer",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-973-7249",
    accountId: "CUST-00018",
    memberSince: "Mar 2023",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260518", product: "NextPlay Console", status: "in_transit", carrier: "USPS", trackingNumber: "TRK996413215", eta: "Apr 6", date: "Apr 2" },
    ],
    bestFor: ["wismo"],
    suggestedQuestions: {
      wismo:        ["Where is my NextPlay Console? ETA was Apr 6 and it's past that", "My USPS shipment TRK996413215 hasn't updated in 3 days", "Can you check if my console is still on track?", "Is there a way to expedite my USPS shipment?"],
      cancellation: ["If my console is further delayed I want to cancel VE-20260518", "What's the Gold member policy for late deliveries?"],
      "product-rec":["What games and accessories are available for NextPlay?"],
      "store-desk": ["Can I pick up a NextPlay Console at a Denver store instead?"],
    },
  },
  {
    id: "alicet",
    name: "Alice Thomas",
    role: "Returning Customer",
    avatarInitials: "AT",
    avatarBg: "from-green-500 to-emerald-600",
    tagLine: "Camera pickup order — store investigation open, 97% concern flag",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-787-4334",
    accountId: "CUST-00025",
    memberSince: "Jul 2022",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260525", product: "PixelSnap Creator Kit", status: "pickup_processing", carrier: "FedEx", trackingNumber: "TRK916316282", eta: "Apr 23", date: "Apr 21" },
    ],
    bestFor: ["store-desk", "wismo"],
    suggestedQuestions: {
      "store-desk": ["My camera kit is being processed for store pickup — when will it be ready?", "Which Albany store has my PixelSnap Creator Kit?", "The store hasn't confirmed my pickup VE-20260525 — can someone check?"],
      wismo:        ["My pickup order shows an investigation flag — what's wrong?", "Why does VE-20260525 have a 97% risk flag if it's just a store pickup?"],
      "product-rec":["What accessories come with the PixelSnap Creator Kit?", "Best tripods and lighting for the PixelSnap camera?"],
      cancellation: ["I want to cancel my store pickup and order delivery instead"],
    },
  },
  {
    id: "jack",
    name: "Jack Martinez",
    role: "Returning Customer",
    avatarInitials: "JM",
    avatarBg: "from-red-400 to-orange-500",
    tagLine: "Speaker delayed in transit — wearable refund of $254 gift card just settled",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-812-4526",
    accountId: "CUST-00026",
    memberSince: "Oct 2021",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260526", product: "SoundDock Home",  status: "delayed",   carrier: "OnTrac", trackingNumber: "TRK479844100", eta: "Apr 27", date: "Apr 21" },
      { orderId: "VE-20260527", product: "NovaRing",        status: "returned",  carrier: "FedEx",  trackingNumber: "TRK431952172", date: "Apr 10" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["My SoundDock Home is delayed — sortation issue?", "Will VE-20260526 arrive by Apr 27? I need it for a party", "Can OnTrac expedite my speaker delivery TRK479844100?"],
      cancellation: ["My NovaRing refund was $254 gift card — I wanted cash back", "Can I convert the gift card refund to original payment?", "I want to cancel my speaker if it won't arrive on time"],
      "product-rec":["What's a great portable speaker for outdoor parties?", "Best smartwatch alternatives to the NovaRing?"],
      "store-desk": ["Is the SoundDock Home available at a Nashville store?"],
    },
  },
  {
    id: "avat",
    name: "Ava Thomas",
    role: "Returning Customer",
    avatarInitials: "AT",
    avatarBg: "from-rose-400 to-pink-500",
    tagLine: "Indoor cam delayed + tablet label created — $649 refund pending (Scenario 1)",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-273-5808",
    accountId: "CUST-00035",
    memberSince: "Nov 2023",
    loyaltyTier: "Silver",
    orders: [
      { orderId: "VE-20260544", product: "HomeSense Indoor Cam", status: "delayed",      carrier: "FedEx", trackingNumber: "TRK583432923", eta: "Mar 22", date: "Mar 18" },
      { orderId: "VE-20260545", product: "ArcSlate 13",          status: "label_created", carrier: "USPS",  trackingNumber: "TRK762914018", eta: "Apr 17", date: "Apr 13" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["My indoor camera has been delayed since Mar 22 — it's been 5 weeks", "My tablet label was created Apr 13 but nothing has moved", "Can you check both VE-20260544 and VE-20260545?"],
      cancellation: ["I want to cancel my tablet order VE-20260545 — I see a $649 refund was initiated", "What's the status of my tablet refund?", "Can I cancel the camera too — it's way overdue?", "I want to reorder with faster shipping after cancellation"],
      "product-rec":["What's a faster-shipping alternative to the ArcSlate 13?", "Good indoor security cameras that ship in 1-2 days?"],
      "store-desk": ["Is the ArcSlate 13 available for pickup at a Nashville store?"],
    },
  },
  {
    id: "aliceth",
    name: "Alice Thompson",
    role: "Power Buyer",
    avatarInitials: "AT",
    avatarBg: "from-blue-400 to-cyan-500",
    tagLine: "Two store pickups in Chicago — camera processing + air fryer ready",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-502-2873",
    accountId: "CUST-00036",
    memberSince: "Apr 2022",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260546", product: "PixelSnap Mirrorless",   status: "pickup_processing", carrier: "UPS", trackingNumber: "TRK841176703", eta: "Mar 26", date: "Mar 21" },
      { orderId: "VE-20260547", product: "ChefMate Air Fryer XL",  status: "ready_for_pickup",  carrier: "UPS", trackingNumber: "TRK694180283", eta: "Apr 9",  date: "Apr 2" },
    ],
    bestFor: ["store-desk"],
    suggestedQuestions: {
      "store-desk": ["I have two store pickups in Chicago — can I pick both up at once?", "My PixelSnap Mirrorless is still processing after 5 weeks — why?", "My Air Fryer is ready for pickup — which store?", "Can I combine VE-20260546 and VE-20260547 for one trip?"],
      wismo:        ["Why is my camera pickup still processing since Mar 21?", "My air fryer pickup was ready Apr 9 — is it still there?"],
      "product-rec":["Best lenses and accessories for the PixelSnap Mirrorless?", "Recommend a recipe book or accessories for the ChefMate Air Fryer?"],
      cancellation: ["I want to cancel my camera pickup — too long of a wait"],
    },
  },
  {
    id: "levi",
    name: "Levi Lee",
    role: "Returning Customer",
    avatarInitials: "LL",
    avatarBg: "from-emerald-400 to-teal-500",
    tagLine: "Headphones delivered + phone in transit — good upgrade candidate",
    email: "shikhar.kansal@nurix.ai",
    phone: "+1-555-469-9137",
    accountId: "CUST-00040",
    memberSince: "Jan 2023",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260554", product: "SonicWave Lite",     status: "delivered",  carrier: "LaserShip", trackingNumber: "TRK789559326", date: "Mar 23" },
      { orderId: "VE-20260555", product: "VoltEdge One Pro",   status: "in_transit", carrier: "FedEx",     trackingNumber: "TRK798865464", eta: "Apr 13", date: "Apr 11" },
    ],
    bestFor: ["wismo", "product-rec"],
    suggestedQuestions: {
      wismo:        ["Where is my VoltEdge One Pro phone? ETA was Apr 13", "Can you track FedEx shipment TRK798865464 for me?"],
      "product-rec":["My SonicWave Lite arrived — what case or stand works with the VoltEdge One Pro?", "Best screen protector for the VoltEdge One Pro?", "I have the headphones and phone — what else completes my mobile setup?", "Recommend a wireless charger that works with VoltEdge One Pro?"],
      cancellation: ["I want to cancel my phone order VE-20260555 before delivery", "Can I upgrade to the VoltEdge Pro model instead?"],
      "store-desk": ["Can I pick up my phone at a Phoenix store instead?"],
    },
  },
  {
    id: "isabelal",
    name: "Isabella Lewis",
    role: "Returning Customer",
    avatarInitials: "IL",
    avatarBg: "from-violet-400 to-purple-500",
    tagLine: "Printer delayed by weather + tablet refund $399 gift card in progress",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-621-5030",
    accountId: "CUST-00047",
    memberSince: "May 2022",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260568", product: "PrintFlow OfficePro",  status: "delayed",  carrier: "OnTrac", trackingNumber: "TRK786640624", eta: "Apr 10", date: "Apr 4" },
      { orderId: "VE-20260569", product: "VoltEdge Tab 11",      status: "returned", carrier: "USPS",   trackingNumber: "TRK456035055", date: "Apr 7" },
    ],
    bestFor: ["wismo", "cancellation"],
    suggestedQuestions: {
      wismo:        ["My printer was supposed to arrive Apr 10 — weather delay?", "Can OnTrac expedite VE-20260568 TRK786640624?", "It's been 3 weeks since my printer shipped — any update?"],
      cancellation: ["My tablet refund of $399 was to gift card — I wanted cash", "Can I convert my tablet refund to original payment?", "I want to cancel my printer if it doesn't arrive this week"],
      "product-rec":["What's a good office printer that ships faster than OnTrac?", "Best tablet alternatives to the VoltEdge Tab 11?"],
      "store-desk": ["Is the PrintFlow OfficePro available at a Minneapolis store?"],
    },
  },
  {
    id: "aria",
    name: "Aria Walker",
    role: "VIP Member",
    avatarInitials: "AW",
    avatarBg: "from-amber-400 to-yellow-500",
    tagLine: "Party speaker ready for pickup + sound dock in transit — Platinum buyer",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-570-1983",
    accountId: "CUST-00049",
    memberSince: "Jun 2020",
    loyaltyTier: "Platinum",
    orders: [
      { orderId: "VE-20260572", product: "VoltEdge Party Speaker", status: "ready_for_pickup", carrier: "LaserShip", trackingNumber: "TRK406998560", eta: "Apr 20", date: "Apr 11" },
      { orderId: "VE-20260573", product: "SoundDock Mini",         status: "in_transit",       carrier: "FedEx",     trackingNumber: "TRK601727321", eta: "Apr 6",  date: "Apr 2" },
    ],
    bestFor: ["store-desk", "product-rec"],
    suggestedQuestions: {
      "store-desk": ["My party speaker is ready for pickup in Albany — which store?", "How long is my pickup window for VE-20260572?", "Can a family member pick up the speaker for me?"],
      wismo:        ["My SoundDock Mini was due Apr 6 — is it still in transit?", "Can you track FedEx TRK601727321 for my dock?"],
      "product-rec":["I'm setting up a full home audio system — what do you recommend?", "Best subwoofer to pair with the VoltEdge Party Speaker?", "Complete outdoor party setup recommendations under $1,000?", "What's the difference between SoundDock Mini and the full SoundDock Home?"],
      cancellation: ["I want to return the SoundDock Mini if it arrives late"],
    },
  },
  {
    id: "maya",
    name: "Maya Thomas",
    role: "Power Buyer",
    avatarInitials: "MT",
    avatarBg: "from-slate-500 to-gray-600",
    tagLine: "Gaming laptop return — $1,599 store credit processing + partial smart hub delivery",
    email: "suniras.rapelli@nurix.ai",
    phone: "+1-555-465-4806",
    accountId: "CUST-00053",
    memberSince: "Feb 2021",
    loyaltyTier: "Gold",
    orders: [
      { orderId: "VE-20260580", product: "Aurora Gaming 16",    status: "returned",   carrier: "UPS",  trackingNumber: "TRK153948228", date: "Apr 1" },
      { orderId: "VE-20260581", product: "HomeSense Smart Hub", status: "in_transit", carrier: "USPS", trackingNumber: "TRK469332987", eta: "Apr 4", date: "Apr 2" },
    ],
    bestFor: ["cancellation"],
    suggestedQuestions: {
      cancellation: ["My Aurora Gaming 16 return — when does my $1,599 store credit arrive?", "I want the refund in cash, not store credit — can that be changed?", "My laptop return was processed Mar 28 — Apr 18 credit ETA has passed", "Can I apply the store credit to a new laptop order?"],
      wismo:        ["My Smart Hub was partially delivered — where are the remaining items?", "When will the rest of my HomeSense Smart Hub arrive?"],
      "product-rec":["I'm looking to reorder a gaming laptop — what's better than the Aurora Gaming 16?", "Complete gaming and streaming setup under $2,000?"],
      "store-desk": ["Can I pick up the Smart Hub parts at an Albany store?"],
    },
  },

  // ── Copa Airlines passengers (seed only — the live profile overrides via get_booking) ──
  {
    id: "copa_sofia",
    name: "Sofia Rodríguez",
    role: "Refund + Rebooking",
    avatarInitials: "SR",
    avatarBg: "from-sky-500 to-blue-600",
    tagLine: "Bereavement cancellation PTY → JFK — refund under review, may rebook next month",
    email: "sofia.rodriguez@example.com",
    phone: "+507-6000-2148",
    accountId: "CP9M4L",
    memberSince: "Jan 2022",
    loyaltyTier: "Gold",
    orders: [],
    bestFor: ["refund-status"],
    suggestedQuestions: {
      "refund-status": [
        "I had to cancel my trip after a death in the family — what's my refund status?",
        "Booking CP9M4L, last name Rodríguez.",
        "The destination was New York.",
        "Could I use the refund toward a new Panama City to New York trip around June 18?",
      ],
    },
  },
  {
    id: "copa_ana",
    name: "Ana Morales",
    role: "Baggage + Voucher",
    avatarInitials: "AM",
    avatarBg: "from-teal-500 to-emerald-600",
    tagLine: "Bag delayed 2 days BOG → PTY → MIA — reimbursement pending, voucher not opened",
    email: "ana.morales@example.com",
    phone: "+57-300-555-0148",
    accountId: "CP7KQ2",
    memberSince: "Jun 2023",
    loyaltyTier: "Silver",
    orders: [],
    bestFor: ["baggage-reimbursement"],
    suggestedQuestions: {
      "baggage-reimbursement": [
        "My bag arrived two days late and I submitted receipts — where's my reimbursement?",
        "Booking CP7KQ2, last name Morales.",
        "The destination was Miami.",
        "Can you resend the voucher and the receipt upload link?",
      ],
    },
  },
];

export function getPersonaById(id: string): PersonaConfig | undefined {
  return PERSONAS.find((p) => p.id === id);
}

// ─── Shopify customer → PersonaConfig ────────────────────────────────────────

const AVATAR_GRADIENTS = [
  "from-pink-400 to-pink-600",
  "from-blue-400 to-blue-600",
  "from-violet-400 to-violet-600",
  "from-emerald-400 to-emerald-600",
  "from-amber-400 to-amber-600",
  "from-rose-400 to-rose-600",
  "from-cyan-400 to-cyan-600",
];

export const SHOPIFY_PERSONA_ID_PREFIX = "shopify_";

function tierFromSpend(amount: number): PersonaConfig["loyaltyTier"] {
  if (amount >= 1000) return "Platinum";
  if (amount >= 500)  return "Gold";
  if (amount >= 100)  return "Silver";
  return "Bronze";
}

function initialsFor(first: string, last: string, fallback: string): string {
  const a = first?.[0] ?? "";
  const b = last?.[0]  ?? "";
  const combined = (a + b).toUpperCase();
  if (combined) return combined;
  const f = fallback.replace(/[^A-Za-z]/g, "");
  return (f.slice(0, 2) || "C").toUpperCase();
}

const MONTH_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function formatMemberSince(iso: string | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${MONTH_SHORT[d.getMonth()]} ${d.getFullYear()}`;
}

export function shopifyCustomerToPersona(c: ShopifyCustomerSummary): PersonaConfig {
  const totalSpent  = parseFloat(c.totalSpent) || 0;
  const avatarIndex = Math.abs(c.id) % AVATAR_GRADIENTS.length;

  return {
    id:               `${SHOPIFY_PERSONA_ID_PREFIX}${c.id}`,
    name:             c.displayName,
    role:             "Customer",
    avatarInitials:   initialsFor(c.firstName, c.lastName, c.displayName),
    avatarBg:         AVATAR_GRADIENTS[avatarIndex],
    tagLine:          c.tags[0] ?? (c.ordersCount > 0 ? "Returning Customer" : "New Customer"),
    email:            c.email ?? "—",
    phone:            c.phone ?? "—",
    accountId:        `CUST-${c.id}`,
    memberSince:      formatMemberSince(c.createdAt),
    loyaltyTier:      tierFromSpend(totalSpent),
    orders:           [],
    ordersCount:      c.ordersCount,
    bestFor:          [],
    suggestedQuestions: {},
  };
}
